import {
  CustomAnalyticsQueryVersion,
  CustomAnalyticsQueryVersionSchema,
} from "@redotech/redo-analytics-custom-analytics/query/custom-analytics-report-query";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";
import {
  CustomReportDraftMaxAttemptsSchema,
  CustomReportDraftOutputShape,
  CustomReportDraftTeamIdSchema,
} from "./custom-report-draft-schema";

export const draftCustomReportAstFromSql = unaryRpc({
  name: "draftCustomReportAstFromSql" as const,
  description:
    "Draft a custom analytics semantic query AST from hand-written Snowflake SQL by prompting the given query version's custom analytics agent and re-prompting with the compiler error until it compiles. The result is a proposal that still must be validated, previewed, and compared against the source SQL.",
  input: z.object({
    sql: z.string().trim().min(1).max(20_000),
    teamId: CustomReportDraftTeamIdSchema,
    notes: z.string().trim().max(4000).nullable().default(null),
    maxAttempts: CustomReportDraftMaxAttemptsSchema.default(3),
    version: CustomAnalyticsQueryVersionSchema.default(
      CustomAnalyticsQueryVersion.V1,
    ),
  }),
  output: z.object(CustomReportDraftOutputShape),
});

export type DraftCustomReportAstFromSqlInput = z.infer<
  typeof draftCustomReportAstFromSql.input
>;
export type DraftCustomReportAstFromSqlOutput = z.infer<
  typeof draftCustomReportAstFromSql.output
>;
